module.exports = __webpack_public_path__ + "img/abstract-shapes-21.4baa01c0.svg";